import { IAppState } from '../../redux';
import { IBuyPackageData } from '../../reducers/types';

export const selectBuyPackageModalData = (state: IAppState): IBuyPackageData => {
  return state.buyPackage.data;
};
